import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UpdateJobGQL } from 'graphql.generated';
import { DialogService } from 'primeng/dynamicdialog';
import { catchError, EMPTY, map, mergeMap, tap } from "rxjs";

import { CloseJobDialogState } from '../../job/job-create/close-job-component/close-job-component.component';

import { DetailsHelperService } from '../../services/details-helper.service';
import { FreyaNotificationsService } from '../../services/freya-notifications.service';
import { CloseJobComponent } from '../close-job/close-job.component';

import { RightPanelComponentActions } from './right-panel.actions';


export const closeJobDialogPrompted = createEffect((
    actions$ = inject(Actions),
    dialogService = inject(DialogService),
  ) => {
      return actions$.pipe(
        ofType(RightPanelComponentActions.closeJobDialogPrompted),
        map(({ job }) => {

          dialogService.open(CloseJobComponent, {
            header: 'Close Job',
            width: '20rem',
            data: {
              job,
            } as CloseJobDialogState,
          });
        }),
      );
    },
    { functional: true, dispatch: false },
  );

export const reopenJobClicked = createEffect((
    actions$ = inject(Actions),
    updateJob = inject(UpdateJobGQL),
    detailsHelper = inject(DetailsHelperService),
    notify = inject(FreyaNotificationsService),
  ) => {
    return actions$.pipe(
      ofType(RightPanelComponentActions.reopenJobButtonClicked),
      mergeMap(({ jobId }) =>
        updateJob.mutate({
          updateJobs: [{
            jobId,
            closeJob: false,
          }],
        }).pipe(
          tap(() => {
            detailsHelper.pushUpdate({
              id: jobId,
              type: 'Jobs',
              action: 'update',
            });

            notify.success('Job reopened');
          }),
          catchError(err => {
            notify.apolloError('Failed to reopen job', err);
            return EMPTY;
          })
        )
      )
    );
  }, { functional: true, dispatch: false });